/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";
import { useForm } from "cms/forms/context";
import { useFormState } from "cms/forms/context/hooks/use-form-state";
import { FormProvider } from "@simplicitycms/simplicity-forms";
import { Form } from "@simplicitycms/simplicity-forms";
// import { useSelector } from "react-redux";
// import { DynamicQuestion } from "cms/forms/form-layout/dynamic-question";
// import { NothingToDisplay } from "cms/forms/form-layout/empty/nothing-to-display";
// import { isArrayEmpty, isArrayNotEmpty } from "utils/empty-exists";

const ComposerForm = (props) => {

    const form_id = props?.form_id;

    const { loadCurrentSchemaForm } = useForm();
    // const website = useSelector((state) => state.website.current);

    const { form } = useFormState();
    const name = form?.name;
    // const questions = form?.questions;
    // const domain = website.primary_domain;
    const domain = window.location.host;
    
    const component = {
        form_id, 
        description: form.description,
    };

    useEffect(() => {
        if (form_id) {
            loadCurrentSchemaForm(form_id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form_id]);

    return (
        <div>
            <h3>{name}</h3>

            <FormProvider domain={domain}>
                <Form component={component} />
            </FormProvider>
            
            {/*{isArrayNotEmpty(questions) &&*/}
            {/*    questions.map((question) => {*/}
            {/*        return (*/}
            {/*            <div key={question.guid} style={{ flex: "1" }}>*/}
            {/*                <DynamicQuestion question={question} />*/}
            {/*            </div>*/}
            {/*        );*/}
            {/*    })*/}
            {/*}*/}
            {/*{isArrayEmpty(questions) &&*/}
            {/*    <NothingToDisplay />*/}
            {/*}*/}
        </div>
    );
};

export { ComposerForm };
